<ng-container *mobxAutorun>
  <div class="d-flex flex-column h-100">
    <!-- Application header -->
    <header id="lf-header">
      <ng-content select="lf-top-bar"></ng-content>
    </header>

    <!-- Content -->
    <div #mainContainer id="lf-main-container" class="container-fluid">
      <div id="lf-main-row" class="row">
        <!-- Container of the tree nav (collapsible from the `top-bar`) -->
        <div
          #treeNavContainer
          id="lf-tree-nav-container"
          class="col-xl-2 col-md-3 col-sm-12"
          [class.show]="isTreeNavVisible"
          [class.animate]="_shouldBackdropExist"
          (transitionend)="_onTreeNavTransitionEnd()"
        >
          <ng-content select="lf-tree-nav"></ng-content>
        </div>

        <!-- Main content -->
        <div
          #mainContent
          id="lf-main-content"
          class="col-xl-10 col-md-9 col-sm-12"
        >
          <ng-content></ng-content>

          <!-- Validation panel -->
          <lf-validation-panel></lf-validation-panel>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="_shouldBackdropExist"
    class="modal-backdrop fade d-md-none"
    [class.show]="_isBackdropVisible"
    (click)="hideTreeNav()"
    (transitionend)="_onBackdropTransitionEnd()"
  ></div>
</ng-container>
